import { useEffect, useState } from "react";
import { Route, Routes as ReactRoutes, useLocation } from "react-router";
import { NotLandingPaths, Routes } from "src/navigation";
import { PrivateRoute } from "../private-route/private-route";
import { useGetDossier } from "src/networking/terminals";

export const NavigationRoot = () => {
  const { pending: pendingDossier } = useGetDossier();
  const { pathname } = useLocation();
  const isNotLanding = NotLandingPaths.includes(pathname);
  const [showItem, setShowItem] = useState(false);

  useEffect(() => {
    if (isNotLanding && pendingDossier) {
      setShowItem(false);
    } else {
      setShowItem(true);
    }
  }, [isNotLanding, pendingDossier]);

  return (
    <ReactRoutes>
      {Object.values(Routes).map(({ path, element, private: pvt }, index) => (
        <Route
          key={index}
          path={path}
          element={
            pvt ? (
              <PrivateRoute element={element} />
            ) : isNotLanding && pendingDossier ? (
              <></>
            ) : (
              showItem && element
            )
          }
        />
      ))}
    </ReactRoutes>
  );
};
